const COLOR_FFFFFF = '#FFFFFF';

export enum System {
  Primary = '#2A3EE1',
  Dark = '#1A27BA',
  Light = '#D4DEFF',
  Lightest = '#F0F4FF',
  Success = '#52C41A',
}

export enum Neutrals {
  Dark = '#121212',
  Text = 'rgba(0, 0, 0, 0.88)',
  Gray = 'rgba(0, 0, 0, 0.45)',
  Border = '#E8E8E8',
  Light = '#F5F5F5',
  Paper = COLOR_FFFFFF,
  Surface = COLOR_FFFFFF,
}

export enum NeutralsFixed {
  Dark = '#121212',
  Text = 'rgba(0, 0, 0, 0.88)',
  Gray = 'rgba(0, 0, 0, 0.45)',
  Border = '#E8E8E8',
  Light = '#F5F5F5',
  Paper = COLOR_FFFFFF,
  Surface = COLOR_FFFFFF,
}

export enum TextContrast {
  Primary = NeutralsFixed.Paper,
  Secondary = Neutrals.Dark,
}

export enum Feedback {
  Alert = '#FF4D4F',
  AlertLight = '#FFF2F0',
  Success = '#52C41A',
  SuccessLight = '#F6FFED',
  Warning = '#FAAD14',
  WarningLight = '#FFFBE6',
  Info = '#2A3EE1',
  InfoLight = '#F0F4FF',
  InfoSpecial = '#ABBDFF',
}

export enum Brand {
  Primary = '#2A3EE1',
  Dark = '#1A27BA',
  Darkest = '#2B373F',
  Light = '#D4DEFF',
  Lightest = '#F0F4FF',
  SpecialLight = '#FDF0FF',
  Special = '#E3C4EE',
  SpecialDark = '#5E376D',
}

export enum Overlay {
  Light = 'rgba(0, 0, 0, 0.15)',
  Default = 'rgba(0, 0, 0, 0.45)',
  Hover = 'rgba(0, 0, 0, 0.88)',
}

export enum OverlayFixed {
  Light = 'rgba(0, 0, 0, 0.15)',
  Default = 'rgba(0, 0, 0, 0.45)',
  Hover = 'rgba(0, 0, 0, 0.88)',
}

export enum Pro {
  Badge = '#F4C304',
}
